export default __webpack_public_path__ + "media/images/images/backgrounds/bg-2-old-3593ed803d68843252cff9736943b775.jpg";